import React from 'react';

import { RecommendationPresentationPage } from './component/RecommendationPresentation/RecommendationPresentationPage';

export const RecommendationPresentation = ({ teamBuilding }: { teamBuilding: boolean }) => (
  <RecommendationPresentationPage teamBuilding={teamBuilding} />
);
